export default __webpack_public_path__ + "static/media/students.7af0b33f.png";